import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";

export class vnAppZoneContent extends vnAppZone {

    protected factory: pageFactory;

    public constructor(destination) {
        super(destination);
        this.zoneName = "Content";

        this.isOnAlwaysReloadMode = true;
        this.factory = new pageFactory();
    }


    protected defineRoutes_getModule(moduleKey: string){
        let _mythis = this;
        return function(){
            // obtain the right module object
            let moduleObj = _mythis.factory.get_actionHandler(moduleKey, _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }

    }

    defineRoutes() {
        let _mythis = this;

        //define routes
        this.addForRoute('/', _mythis.defineRoutes_getModule("home"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/home', _mythis.defineRoutes_getModule("home"), _mythis.defineRoutes_getModule("login") );

        this.addForRoute('/login', _mythis.defineRoutes_getModule("login"), null );
        this.addForRoute('/logs', _mythis.defineRoutes_getModule("logs"), null );
        this.addForRoute('/tasks', _mythis.defineRoutes_getModule("tasks"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/tasks/add', _mythis.defineRoutes_getModule("tasks_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/reset/token/:token', _mythis.defineRoutes_getModule("reset_password"), null );
        this.addForRoute('/user/edit/:id', _mythis.defineRoutes_getModule("users_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/user/profile/:id', _mythis.defineRoutes_getModule("users_profile"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/user/add', _mythis.defineRoutes_getModule("users_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/users', _mythis.defineRoutes_getModule("users"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/task_tree', _mythis.defineRoutes_getModule("taskTree"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/data_import', _mythis.defineRoutes_getModule("data_import"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/article_session_diagnostics', _mythis.defineRoutes_getModule("articleSessionDiagnostics"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/writer/volume_tracker', _mythis.defineRoutes_getModule("writer_volume_tracker"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/gp_sheet', _mythis.defineRoutes_getModule("gp_sheet"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/feature_points', _mythis.defineRoutes_getModule("dev_featurePoints"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/roi_tool', _mythis.defineRoutes_getModule("roi_tool"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/editorial_insights', _mythis.defineRoutes_getModule("editorialInsights"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/search_query', _mythis.defineRoutes_getModule("searchQuery"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/update_comparison', _mythis.defineRoutes_getModule("updateComparison"), _mythis.defineRoutes_getModule("login") );

        this.addForRoute('/facebook_page/post/list', _mythis.defineRoutes_getModule("platformStats_fbPage_post"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/facebook_page/post/daily_stats/list', _mythis.defineRoutes_getModule("platformStats_fbPage_postDaily"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/facebook_page/post/hourly_stats/list', _mythis.defineRoutes_getModule("platformStats_fbPage_postHourly"), _mythis.defineRoutes_getModule("login") );

        // Roles routes
        this.addForRoute('/roles/edit', _mythis.defineRoutes_getModule("roles_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/roles/edit/:id', _mythis.defineRoutes_getModule("roles_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/roles/view/:id', _mythis.defineRoutes_getModule("roles_view"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/roles', _mythis.defineRoutes_getModule("roles"), _mythis.defineRoutes_getModule("login") );

        // goals routes
        this.addForRoute('/goals/edit', _mythis.defineRoutes_getModule("goal_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/goals/edit/:id', _mythis.defineRoutes_getModule("goal_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/goals/view/:id', _mythis.defineRoutes_getModule("goal_view"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/goals', _mythis.defineRoutes_getModule("goals"), _mythis.defineRoutes_getModule("login") );

        // network groups routes
        this.addForRoute('/network_groups/edit', _mythis.defineRoutes_getModule("networkGroup_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/network_groups/edit/:id', _mythis.defineRoutes_getModule("networkGroup_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/network_groups/view/:id', _mythis.defineRoutes_getModule("networkGroup_view"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/network_groups', _mythis.defineRoutes_getModule("networkGroup"), _mythis.defineRoutes_getModule("login") );

        // newsletter routes
        this.addForRoute('/newsletter_performance', _mythis.defineRoutes_getModule("newsletterPerformance"), _mythis.defineRoutes_getModule("login") );

        // Initiative model report route.
        this.addForRoute('/initiative_model_report', _mythis.defineRoutes_getModule("initiativeModel_report"), _mythis.defineRoutes_getModule("login") );


        // internal costs routes.
        this.addForRoute('/internal_cost', this.defineRoutes_getModule("internal_cost"), this.defineRoutes_getModule("login") );

        // speed test routes.
        this.addForRoute('/speed_test', this.defineRoutes_getModule("speedTestReport"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_insights', this.defineRoutes_getModule("speedTestInsightsDomainConfig"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_insights/add', this.defineRoutes_getModule("speedTestInsightsDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_insights/edit/:id', this.defineRoutes_getModule("speedTestInsightsDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_insights/edit/:id/:idContentType', this.defineRoutes_getModule("speedTestInsightsDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_insights/log/:id', this.defineRoutes_getModule("speedTestInsightsLog"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_crux', this.defineRoutes_getModule("speedTestCruxDomainConfig"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_crux/add', this.defineRoutes_getModule("speedTestCruxDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_crux/edit/:id', this.defineRoutes_getModule("speedTestCruxDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_ads_audit', this.defineRoutes_getModule("speedTestAdsAuditDomainConfig"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_ads_audit/add', this.defineRoutes_getModule("speedTestAdsAuditDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_ads_audit/edit/:id', this.defineRoutes_getModule("speedTestAdsAuditDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_ads_audit/edit/:id/:idContentType', this.defineRoutes_getModule("speedTestAdsAuditDomainConfigEdit"), this.defineRoutes_getModule("login") );
        this.addForRoute('/speed_test/config_ads_audit/log/:id', this.defineRoutes_getModule("speedTestAdsAuditLog"), this.defineRoutes_getModule("login") );


        // transaction initiative splits routes
        this.addForRoute('/txn_init_split/edit/', _mythis.defineRoutes_getModule("txnInitSplit_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/txn_init_split/brand/:idBrand/user/:idUser/edit/', _mythis.defineRoutes_getModule("txnInitSplit_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/txn_init_split/brand/:idBrand/user/:idUser/view/', _mythis.defineRoutes_getModule("txnInitSplit_view"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/txn_init_split', _mythis.defineRoutes_getModule("txnInitSplit"), _mythis.defineRoutes_getModule("login") );

        this.addForRoute('/facebook_content_comparison', _mythis.defineRoutes_getModule("facebook_content_comparison"), _mythis.defineRoutes_getModule("login") );

        // affiliate revenue report routes.
        this.addForRoute('/affiliate_revenue_report', _mythis.defineRoutes_getModule("affiliate_revenue_report"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/car_marketplace_report', _mythis.defineRoutes_getModule("car_marketplace_report"), _mythis.defineRoutes_getModule("login") );

        // google overview routes.
        this.addForRoute('/google_overview', _mythis.defineRoutes_getModule("google_overview"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/google_overview_article', _mythis.defineRoutes_getModule("google_overview_article"), _mythis.defineRoutes_getModule("login") );

        // Feature Points routes
        this.addForRoute('/feature_points', _mythis.defineRoutes_getModule("featurePoints"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/feature_points/config/view', _mythis.defineRoutes_getModule("featurePointsConfig_view"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/feature_points/config/holidays/year/:year/quarter/:quarter/edit', _mythis.defineRoutes_getModule("featurePointsHolidays_edit"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/feature_points/config/assignee/:idAssignee/edit', _mythis.defineRoutes_getModule("featurePointsAssignee_edit"), _mythis.defineRoutes_getModule("login") );

        // tag performance report routes.
        this.addForRoute('/tag_performance_report', _mythis.defineRoutes_getModule("topicalityReport"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/tag_performance_article_report/brand/:idBrand/tag/:idTag/', _mythis.defineRoutes_getModule("tagPerformanceArticleReport"), _mythis.defineRoutes_getModule("login") );

        // article Revenue route
        this.addForRoute('/audience_value_tool', _mythis.defineRoutes_getModule("articleRevenue"), _mythis.defineRoutes_getModule("login") );

        // Jira Task route
        this.addForRoute('/jiraTask', _mythis.defineRoutes_getModule("jiraTask"), _mythis.defineRoutes_getModule("login") );

        // Task execute Tree route
        this.addForRoute('/tasks_tree', _mythis.defineRoutes_getModule("taskTree"), _mythis.defineRoutes_getModule("login") );

        // Video Performance route
        this.addForRoute('/video_performance', _mythis.defineRoutes_getModule("videoPerformance"), _mythis.defineRoutes_getModule("login") );

        // Article Limit Draer route
        this.addForRoute('/login_stats', _mythis.defineRoutes_getModule("loginStats"), _mythis.defineRoutes_getModule("login") );

        // Content Investment route
        this.addForRoute('/content_investment', _mythis.defineRoutes_getModule("contentInvestment"), _mythis.defineRoutes_getModule("login") );

        // Segment Report route
        this.addForRoute('/segment_report', _mythis.defineRoutes_getModule("segmentReport"), _mythis.defineRoutes_getModule("login") );

        // Article Analysis route
        this.addForRoute('/article_analysis', _mythis.defineRoutes_getModule("articleAnalysis"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/organic/article_analysis', _mythis.defineRoutes_getModule("articleAnalysis"), _mythis.defineRoutes_getModule("login") ); // Redirect to new article analysis to keep existing bookmarks working
        
        // Heavy Hitters route
        this.addForRoute('/heavy_hitters', _mythis.defineRoutes_getModule("heavyHitters"), _mythis.defineRoutes_getModule("login") );
        
        // Sensai Vault route

        // Leadgen route
        this.addForRoute('/leadgen', _mythis.defineRoutes_getModule("leadgen"), _mythis.defineRoutes_getModule("login") );
        this.addForRoute('/backfill', _mythis.defineRoutes_getModule("backfill"), _mythis.defineRoutes_getModule("login") );

        // DSP Report route
        this.addForRoute('/dsp_report', _mythis.defineRoutes_getModule("dspReport"), _mythis.defineRoutes_getModule("login") );

    }
}



// WEBPACK FOOTER //
// ./js/components/vn_app_zone_content.ts